<template>
  <div class="content-wrapper">
    <div class="ml-auto auto md:block cursor-pointer">
      <vs-button type="border" icon-pack="feather" color="primary" icon="icon-plus" @click="createProjectPopup=true" class="mb-base" style="margin:10px;"></vs-button>
    </div>
    <div class="vx-row">
      <div class="ml-auto md:block cursor-pointer">
        <vs-popup classContent="popup-example" title="프로젝트 생성" :active.sync="createProjectPopup" @cancel="clearFields"  @close="clearFields">
          <h4 class="text-center">프로젝트를 생성 합니다.</h4> &nbsp;
          <div class="vs-con-input w-full">
            <vs-input icon-pack="feather" color="dark" icon="icon-edit-2" size="large" placeholder="프로젝트명을 입력하세요." v-model="projectName" class="is-label-placeholder w-full lg:w-full mb-4" />
            <br/>
            <vs-button :disabled="!validateForm" class="w-full mb-2" @click="createProject()" color="primary" type="filled">생성</vs-button>
          </div>
        </vs-popup>
      </div>
    </div>
    <div class="vx-row w-full">
      <projectItem style="float: left; margin: 10px;" v-for="project in projects" v-bind:key="project.id" :projectInfo="project"/>
    </div>
  </div>
</template>

<script>
import ProjectItem from "@/views/apps/space/dashboard/project/ProjectItem.vue"
export default {
  components: {
    'projectItem': ProjectItem
  },
  created() {
    if(this.$store.state.space.ActiveSpaceInfo.id == 0 && this.$route.params.spaceId == null){
      this.$vs.dialog({
        color: 'danger',
        title: `error`,
        text: 'Workspace 주소가 정확한지 확인해 주세요.',
        accept: this.acceptErrorAlert
      })
      return
    }
    if(this.$store.state.space.ActiveSpaceInfo.id == 0){
      this.$store.dispatch('space/getWorkspace', this.$route.params.spaceId).then((resolve) => {
        if(resolve.data.result == 'success'){
          this.spaceId = this.$store.state.space.ActiveSpaceInfo.id
          this.$store.dispatch('project/getProject', this.$store.state.space.ActiveSpaceInfo.id)
          .then(() => {
            this.projects = this.$store.state.project.projects
          })
        }
      })
    }else{
      this.spaceId = this.$store.state.space.ActiveSpaceInfo.id
      this.$store.dispatch('project/getProject', this.$store.state.space.ActiveSpaceInfo.id)
      .then(() => {
        this.projects = this.$store.state.project.projects
      })
    }
  },
props: ['projectId'],
  data() {
    return {
      value1: '',
      spaceTitle: '',
      spaceId: 0,
      projects: [],
      projectName: '',
      projectDetail: '',
      createProjectPopup: false,
      allProjectItemVal: false,
      deleteId:0,
    }
  },
  watch: {
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.projectName != '';
    },
  },

  methods: {
    allProjectItem() {
      this.allProjectItemVal = false
    },

    clearFields() {
      this.$nextTick(() => {
        this.projectName = ''
      })
    },
    acceptErrorAlert() {
        this.$router.push('/apps/space')
    },
    createProject() {
      this.clearFields()
      if (this.spaceId == 0){
        this.createProjectPopup = false
        this.$vs.dialog({
          color: 'danger',
          title: 'error',
          text: '워크 스페이스를 다시 선택해 주세요.',
          accept: this.acceptErrorAlert
        })
        return
      }
      const payload = {
        workspaceId: this.spaceId,
        title: this.projectName,
        detail: this.projectDetail
      }
      this.$store.dispatch('project/createProject', payload)
      .then((response) => {
        if(response.data.result == 'success') {
          this.projects = this.$store.state.project.projects
          this.createProjectPopup = false
        }
      }).catch(error => {
        this.$vs.notify({
          title: 'Error',
          text: error.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
    }
  }
}

</script>

<style>
.bg-img{
  background-image:url('../../../../assets/images/pages/vuexy-login-bg.jpg')
}
</style>
